import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";

export const areasApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    //=============================== get all areas =====================================
    fetchAreas: build.query<
      IJSONResponse,
      { search?: string; cityId?: number | null; areaOnly?: boolean }
    >({
      query: (query) =>
        `areas/searchAreas?${Object.keys(query)
          .map((k) => `${k}=${query[k]}`)
          .join("&")}`,
      providesTags: [ActivityTags.getAreas],
    }),

    //=============================== delete area =====================================
    deleteArea: build.mutation<IJSONResponse, number>({
      query: (areaId) => ({
        url: "areas/deleteArea",
        method: "POST",
        body: { areaId },
      }),
      invalidatesTags: [ActivityTags.getAreas],
    }),

    //=============================== add area =====================================
    addArea: build.mutation<IJSONResponse, { name: string; cityId: number }>({
      query: (body) => ({
        url: "areas/addArea",
        method: "POST",
        body,
      }),
      invalidatesTags: [ActivityTags.getAreas],
    }),
  }),
  overrideExisting: false,
});
